const GetFields = ({audience, id_segment}) => {
    let segmentFound = null
    const excludedFields = ['id_submit', 'id_entity', 'id_action', 'id_source', 'id_journey']

    const configFields = {
        audience: {},
        history : {}
    }

    audience?.segments && audience.segments.map((segment) => {
        if (segment?._id?.$oid === id_segment) {
            segmentFound = segment
        }
    })

    audience?.fields && audience.fields.map((field) => {
        if (field.is_filter === "on") {
            if (field?.field_target === 'audience') {
                configFields.audience[field.name] = field
            }

            if (field?.field_target === 'history') {
                if (!excludedFields.includes(field.name)) {
                    configFields.history[field.name] = field
                }
            }
        }
    })

    return {
        segment: segmentFound,
        fields : configFields
    }


}

export {GetFields}